import { useState, useContext, useEffect, useRef } from "react";
import { Card, Grid, Stack } from "@mui/material";
import balance from "assets/images/balanceBG.png";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { FaEllipsisH } from "react-icons/fa";
import { IoAlertCircleOutline, IoEllipsisVertical, IoCloudUploadOutline } from "react-icons/io5";
import funds from "assets/icons/funds.svg";
import * as S from "./style";
import moment from "moment";
import DashboardLayout from "defaultComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "defaultComponents/Navbars/DashboardNavbar";
import Table from "defaultComponents/Tables/Table";
import { RiEyeFill } from "react-icons/ri";
import ButtonCustom from "components/ButtonCustom/ButtonCustom";
import { BsClockFill } from "react-icons/bs";
import Modal from "components/Modal/Modal";
import { requestWithdraw } from "utils/requests/withdraw";
import { TokenContext } from "context/TokenContext";
import { useParams } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import { getInfluencerFinancial } from "utils/requests/financial";
import showToast from "components/Toast/Toast";
import * as T from "components/Toast/style";
import { getUserWithdrawals } from "utils/requests/withdraw";
import { reportWithdraw } from "utils/requests/withdraw";
import { cancelWithdraw } from "utils/requests/withdraw";
import { uploadProjectFile } from "utils/requests/project";
import MaintenanceModal from "../Cashout/MaintenanceModal";
import useMediaQuery from '@mui/material/useMediaQuery';
import { CircularProgress } from '@mui/material';

const CreditBalance = ({
  openActualModal,
  openFutureModal,
  financialData,
  actualButton,
  futureButton,
  setOpenMaintenanceModal,
}) => {
  const currentBalance = Number(
    ((financialData.monthlyBalance?.currentBalance ?? 0) / 100).toFixed(2)
  ).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const mobile = useMediaQuery("(max-width: 992px)");

  return (
    <Card sx={{ padding: "0", background: "none", backgroundColor: "none" }}>
      <Grid container justifyContent="space-between">
        <Grid display="flex" flexDirection="column" item md={3.8} xl={3.8}>
          <S.CardBox
            p="20px"
            display="flex"
            flexDirection="row"
            sx={{
              backgroundImage: `url(${balance})`,
              backgroundSize: "cover",
              borderRadius: "5px",
            }}
          >
            <Grid>
              <VuiBox display="flex" justifyContent="space-beetween" alignItems="center">
                <VuiTypography variant="caption" color="white" fontWeight="medium" mr="auto">
                  Saldo positivo atual
                </VuiTypography>
              </VuiBox>
              <VuiBox display="flex" justifyContent="space-beetween" alignItems="center">
                <VuiTypography
                  variant="h2"
                  color="white"
                  fontWeight="bold"
                  mr="auto"
                  sx={{ textWrap: "nowrap" }}
                >
                  R$ {currentBalance ?? 0}
                </VuiTypography>
              </VuiBox>
              <VuiBox display="flex" gap="10px">
                <p style={{ color: "white", opacity: "0.7", fontSize: "16px", marginTop: "2px" }}>
                  Saldo futuro:
                </p>
                <p style={{ color: "#5ACC93", fontSize: "18px" }}>
                  {" "}
                  +R${" "}
                  {Number(
                    ((financialData?.monthlyBalance?.pendingBalance ?? 0) / 100).toFixed(2)
                  ).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </p>
              </VuiBox>
            </Grid>
          </S.CardBox>
          <Grid container flexDirection="column" gap="10px"></Grid>
        </Grid>
        <Grid item md={3.8} xl={3.8}>
          {!actualButton && (
            <S.DisabledButton disabled>
              <div>
                <p className="subTitle" style={{ opacity: 0.25 }}>Saldo Atual</p>
                <p className="info" style={{ opacity: 0.25 }}>Sem saldos atuais solicitados</p>
              </div>
            </S.DisabledButton>
          )}
          {actualButton && (
            <S.DisabledButton disabled>
              <div>
                <p className="subTitle">Saldo Atual Solicitado</p>

                {(() => {
                  const entries = financialData?.financialEntries[0]?.filter(
                    entry => entry.withdrawPleaRelated?.status === 'PENDING' && entry.type === 'CURRENT'
                  ) || [];

                  const quantidade = entries.length;
                  const valorTotal = entries.reduce((acc, entry) => acc + entry.value, 0);

                  return (
                    <div>
                      <p className="info">
                        {quantidade} {quantidade === 1 ? "solicitação" : "solicitações"} {quantidade === 1 ? "pendente" : "pendentes"}
                      </p>
                      <p className="info">
                        Valor total: R$ {Number((valorTotal / 100).toFixed(2)).toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                  );
                })()}
              </div>
            </S.DisabledButton>
          )}
        </Grid>
        <Grid item md={3.8} xl={3.8}>
          {!futureButton && (
            <S.DisabledButton disabled>
              <div>
                <p className="subTitle" style={{ opacity: 0.25 }}>Saldo Futuro</p>
                <p className="info" style={{ opacity: 0.25 }}>Sem saldos futuros solicitados</p>
              </div>
            </S.DisabledButton>
          )}
          {futureButton && (
            <S.DisabledButton disabled>
              <div>
                <p className="subTitle">Saldo Futuro Solicitado</p>
                <p className="info">Solicitação em andamento</p>
                {financialData?.financialEntries &&
                  financialData.financialEntries[0]
                    .filter(entry => entry.withdrawPleaRelated?.status === 'PENDING' && entry.type === 'FUTURE')
                    .map((entry, index) => (
                      <div key={index}>

                        <p className="info">
                          <strong>Projeto:</strong> {entry.projectRelated.title.length > (mobile ? 6 : 24)
                            ? `${entry.projectRelated.title.substring(0, mobile ? 6 : 24)}...`
                            : entry.projectRelated.title}{" "}
                          (
                          {`R$ ${Number(((entry.value / 100) * 0.95).toFixed(2)).toLocaleString("pt-BR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}
                          )
                        </p>
                      </div>
                    ))
                }
              </div>
            </S.DisabledButton>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

const InfluencerCashout = () => {
  const [openConfirmActualCashoutModal, setOpenConfirmActualCashoutModal] = useState(false);
  const [openConfirmFutureCashoutModal, setOpenConfirmFutureCashoutModal] = useState(false);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [openReportModal, setOpenReportModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openAttachNfModal, setOpenAttachNfModal] = useState(false);
  const [openBalanceMenu, setOpenBalanceMenu] = useState([]);
  const [openHistoricalMenu, setOpenHistoricalMenu] = useState([]);
  const [pageBalance, setPageBalance] = useState(1);
  const [pageHistorical, setPageHistorical] = useState(1);
  const [financialData, setFinancialData] = useState([]);
  const [cashoutData, setCashoutData] = useState([]);
  const [paginationHistorical, setPaginationHistorical] = useState([]);
  const [chosenEntry, setChosenEntry] = useState();
  const [nfFile, setNfFile] = useState();
  const [openMaintenanceModal, setOpenMaintenanceModal] = useState(false);
  const [isWithdrawLoading, setIsWithdrawLoading] = useState(false);

  const hiddenFileInput = useRef(null);

  const handleFileInputClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleFileChange = (event) => {
    const fileUploaded = event.target.files[0];
    setNfFile(fileUploaded);
  };

  const toggleOpenBalanceMenu = (index) => {
    const updatedBalanceMenu = [...openBalanceMenu];
    updatedBalanceMenu[index] = !updatedBalanceMenu[index];
    setOpenBalanceMenu(updatedBalanceMenu);
  };

  const toggleOpenHistoricalMenu = (index) => {
    const updatedHistoricalMenu = [...openHistoricalMenu];
    updatedHistoricalMenu[index] = !updatedHistoricalMenu[index];
    setOpenHistoricalMenu(updatedHistoricalMenu);
  };

  const { decodedToken } = useContext(TokenContext);
  const role = decodedToken?.type;

  const params = useParams();

  const fetchData = async () => {
    await getInfluencerFinancial(params?.username ?? decodedToken?.username, pageBalance - 1, 100, [
      "CURRENT", "FUTURE",
    ]).then((res) => {
      if (!res?.message) {
        setFinancialData(res);
      }
    });
    await getUserWithdrawals(params?.username ?? decodedToken?.username, pageHistorical - 1, 6).then(
      (res) => {
        if (!res?.message) {
          setCashoutData(res);
        }
      }
    );
  };

  const mobile = useMediaQuery("(max-width: 992px)");

  const calculatePaginationHistorical = () => {
    const roundUpArrSize = cashoutData?.withdrawPleas
      ? Math.ceil(cashoutData?.withdrawPleas[1] / 6)
      : 0;
    const paginationArr = Array.from({ length: roundUpArrSize }, (value, index) => index);
    setPaginationHistorical(paginationArr);
  };

  useEffect(() => {
    fetchData();
  }, [pageHistorical]);

  useEffect(() => {
    if (cashoutData) calculatePaginationHistorical();
  }, [cashoutData]);

  const handleChangeHistorical = (event, value) => {
    setPageHistorical(value);
  };

  const attachNfToWithdraw = async (id, setOpen, message) => {
    setIsWithdrawLoading(true);

    await uploadProjectFile({ id: id, file: nfFile }).then((res) => {
      if (!res.message) {
        showToast(message, "success");
        setNfFile();
        setOpen(false);
        fetchData().finally(() => setIsWithdrawLoading(false));
        return;
      }
      showToast("Falha ao anexar nota fiscal, contate o suporte", "error");
      setIsWithdrawLoading(false);
    });
  };

  const requestActualWithdraw = async () => {
    setIsWithdrawLoading(true);

    const withdraw = {
      value: chosenEntry?.value,
      type: "CURRENT_BALANCE",
      miscInfo: chosenEntry.misc ?? "",
      influencerRelated: decodedToken?.id,
      balances: [chosenEntry.id],
    };
    await requestWithdraw(withdraw).then((res) => {
      if (!res.message && !nfFile?.name) {
        showToast("Saque solicitado com sucesso!", "success");
        setOpenConfirmActualCashoutModal(false);
        fetchData().finally(() => setIsWithdrawLoading(false));
        return;
      }
      if (!res.message && nfFile?.name) {
        attachNfToWithdraw(
          res?.createdPlea.id,
          setOpenConfirmActualCashoutModal,
          "Saque solicitado com sucesso"
        ).finally(() => setIsWithdrawLoading(false));
        return;
      }
      showToast("Falha ao solicitar saque", "error");
      setIsWithdrawLoading(false);
    });
  };

  const requestFutureWithdraw = async () => {
    const withdraw = {
      value: chosenEntry?.value,
      type: "FUTURE_BALANCE",
      miscInfo: chosenEntry.misc ?? "",
      influencerRelated: decodedToken?.id,
      balances: [chosenEntry.id],
    };
    await requestWithdraw(withdraw).then((res) => {
      if (!res.message) {
        showToast("Saque solicitado com sucesso!", "success");
        setOpenConfirmFutureCashoutModal(false);
        fetchData();
        return;
      }
      if (res.message === "Já existe um saque pendente com o saldo futuro para este usuário.") {
        showToast("Já existe um saque futuro pendente", "error");
      } else {
        showToast("Falha ao solicitar saque", "error");
      }
    });
  };

  const reportChosenWithdrawal = async () => {
    await reportWithdraw(chosenEntry?.id).then((res) => {
      if (!res.message) {
        showToast("Saque reportado com sucesso!", "success");
        setOpenReportModal(false);
        return;
      }
      showToast(res?.message, "error");
    });
  };

  const cancelChosenWithdrawal = async () => {
    await cancelWithdraw(chosenEntry?.id).then((res) => {
      if (!res.message) {
        showToast("Saque cancelado com sucesso!", "success");
        setOpenCancelModal(false);
        fetchData();
        return;
      }
      showToast(res?.message, "error");
    });
  };

  const statusColor = {
    APPROVED: "#5ACC93",
    REJECTED: "#FF1A9D",
    PENDING: "#E86A34",
  };

  const statusTranslation = {
    APPROVED: "RESGATE APROVADO",
    REJECTED: "RESGATE RECUSADO",
    PENDING: "EM PROCESSAMENTO",
    USER_CANCELLED: "CANCELADO PELO USUÁRIO",
  };

  const balanceStatusColor = {
    CURRENT: "#5ACC93",
    FUTURE: "#E86A34",
  };

  const filteredEntries = financialData?.financialEntries && financialData.financialEntries[0] 
  ? financialData.financialEntries[0].filter(entry => !entry.withdrawPleaRelated && entry.status !== "PAID")
  : [];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <T.ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Grid container flexDirection="column" gap="15px">
        <CreditBalance
          openActualModal={() => setOpenConfirmActualCashoutModal(true)}
          openFutureModal={() => setOpenConfirmFutureCashoutModal(true)}
          financialData={financialData}
          actualButton={cashoutData?.hasPendingWithdraws?.current}
          futureButton={cashoutData?.hasPendingWithdraws?.future}
          setOpenMaintenanceModal={setOpenMaintenanceModal}
        />
        <Card sx={{ justifyContent: 'space-between', maxHeight: "380px", overflow: "auto" }}>
          <S.TableGrid container flexDirection='column'
            onClick={() => (openBalanceMenu.includes(true) ? setOpenBalanceMenu(openBalanceMenu.map((bool) => false)) : null)}>
            <p>Saldos</p>
            <Grid container flexDirection='column'>
              <Grid container flexDirection='row' alignItems='center' justifyContent='space-between' sx={{ fontSize: '16px', fontWeight: '700' }}>
              </Grid>
              <Table
                columns={[
                  { name: "título", align: "left" },
                  { name: "projeto", align: "left" },
                  { name: "valor", align: "left" },
                  ...(role !== "INFLUENCER" ? [{ name: "empresa", align: "left" }] : []),
                  { name: "observações", align: "left" },
                ]}
                rows={
                  filteredEntries.length > 0 ? filteredEntries.map((entry, index) => {
                      return {
                          título: (
                            <Grid container key={index}>
                              <Grid item md={8} xl={9}>
                                <p>{entry?.description?.length > (mobile ? 6 : 24) ? entry?.description?.substring(0, (mobile ? 6 : 24)) + "..." : entry?.description}</p>
                              </Grid>
                            </Grid>
                          ),
                          projeto: (
                            <Grid container key={index}>
                              <Grid item md={8} xl={9}>
                                <p>{entry?.projectRelated.title > (mobile ? 6 : 24) ? entry?.projectRelated.title.substring(0, (mobile ? 6 : 24)) + "..." : entry?.projectRelated.title}</p>
                              </Grid>
                            </Grid>
                          ),
                          valor: (
                            <Grid container>
                              <p style={{ color: balanceStatusColor[entry?.type] }}>
                                R$ {
                                  Number((entry?.value / 100).toFixed(2))
                                    .toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                }
                              </p>
                            </Grid>
                          ),
                          ...((role !== "INFLUENCER") && {
                            empresa: (
                              <Grid container key={index}>
                                <Grid item md={8} xl={9}>
                                  <p>{entry?.leadRelated.businessName > (mobile ? 6 : 24) ? entry?.leadRelated.businessName.substring(0, (mobile ? 6 : 24)) + "..." : entry?.leadRelated.businessName}</p>
                                </Grid>
                              </Grid>
                            ),
                          }),
                          observações: (
                            <Grid container flexDirection='column'>
                              <Grid container justifyContent='space-between'>
                                <S.MiscInfoGrid item xs={11} xl={11}>
                                  <p>{
                                    entry?.misc
                                      ?
                                      (entry?.misc?.length > 50 ? entry?.misc?.substring(0, 50) + "..." : entry?.misc)
                                      :
                                      "-"
                                  }
                                  </p>
                                </S.MiscInfoGrid>
                                <Grid item xs={1} xl={1} onClick={() => toggleOpenBalanceMenu(index)} data-cy="financial-entry-options" description={entry.description}>
                                  <IoEllipsisVertical
                                    size="20px"
                                    style={{ cursor: "pointer", zIndex: "9999" }}
                                  />
                                </Grid>
                              </Grid>
                              {openBalanceMenu[index] && (
                                <S.OptionsContainer container justifyContent="flex-end">
                                  <S.OptionsGrid display="flex" flexDirection="column" alignItems="center">
                                    <p onClick={() => {
                                      entry.type === "CURRENT"
                                        ? setOpenConfirmActualCashoutModal(true)
                                        : setOpenConfirmFutureCashoutModal(true);
                                      setChosenEntry(entry);
                                    }}
                                    >
                                      Solicitar Saque
                                    </p>
                                  </S.OptionsGrid>
                                </S.OptionsContainer>
                              )}
                            </Grid>
                          )
                        }
                      })
                    : [
                      {
                        título: (
                          <Grid container>
                            <p>Não há saldo disponível</p>
                          </Grid>
                        ),
                        projeto: "",
                        valor: "",
                        empresa: "",
                        observações: "",
                      },
                    ]
                }
              />
            </Grid>
          </S.TableGrid>
        </Card>
        <Card sx={{ maxHeight: "585px", overflow: "auto" }}>
          <S.TableGrid container flexDirection="column"
            onClick={() => (openHistoricalMenu.includes(true) ? setOpenHistoricalMenu(openHistoricalMenu.map((bool) => false)) : null)}>
            <p>Histórico</p>
            <Grid container flexDirection="column">
              <Table
                columns={[
                  { name: "status", align: "left" },
                  { name: "título", align: "left" },
                  { name: "valor", align: "left" },
                  { name: "solicitação", align: "left" },
                  { name: "resposta", align: "left" },
                  { name: "observações", align: "left" },
                ]}
                rows={
                  cashoutData?.withdrawPleas &&
                  cashoutData.withdrawPleas[0]?.map((entry, index) => {
                    return {
                      status: (
                        <Grid container key={index}>
                          <Grid item md={8} xl={9}>
                            <p>{statusTranslation[entry?.status]}</p>
                          </Grid>
                        </Grid>
                      ),
                      título: (
                        <Grid container key={index}>
                          <Grid item md={8} xl={9}>
                            <p>{entry?.balanceRelated?.[0]?.description?.length > (mobile ? 6 : 24) ? entry?.balanceRelated?.[0]?.description?.substring(0, (mobile ? 6 : 24)) + "..." : entry?.balanceRelated?.[0]?.description ?? "-"}</p>
                          </Grid>
                        </Grid>
                      ),
                      valor: (
                        <Grid container>
                          <p style={{ color: statusColor[entry?.status] }}>
                            R${" "}
                            {Number((entry?.value / 100).toFixed(2)).toLocaleString("pt-BR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                        </Grid>
                      ),
                      solicitação: (
                        <p>{entry?.createdAt ? moment(entry?.createdAt).format("L") : "-"}</p>
                      ),
                      resposta: (
                        <p>{entry?.resolvedAt ? moment(entry?.resolvedAt).format("L") : "-"}</p>
                      ),
                      observações: (
                        <Grid container flexDirection="column">
                          <Grid container justifyContent="space-between">
                            <S.MiscInfoGrid item xs={11} xl={11}>
                              <p>{entry?.miscInfo ?? "-"} </p>
                            </S.MiscInfoGrid>
                            <Grid item xs={1} xl={1} onClick={() => toggleOpenHistoricalMenu(index)}>
                              <IoEllipsisVertical
                                size="20px"
                                style={{ cursor: "pointer", zIndex: "9999" }}
                              />
                            </Grid>
                            {openHistoricalMenu[index] && (
                              <S.OptionsContainer container justifyContent="flex-end">
                                <S.OptionsGrid display="flex" flexDirection="column">
                                  <p
                                    onClick={() => {
                                      setOpenDetailsModal(true);
                                      setChosenEntry(entry);
                                    }}
                                  >
                                    Ver Detalhes
                                  </p>
                                  {entry?.type === "CURRENT_BALANCE" &&
                                    !entry?.invoiceCertificateURL && (
                                      <>
                                        <S.Divider />
                                        <p
                                          onClick={() => {
                                            setOpenAttachNfModal(true);
                                            setChosenEntry(entry);
                                          }}
                                        >
                                          Anexar Nota Fiscal
                                        </p>
                                      </>
                                    )}
                                  {entry?.status === "PENDING" && (
                                    <>
                                      <S.Divider />
                                      <p
                                        onClick={() => {
                                          setOpenReportModal(true);
                                          setChosenEntry(entry);
                                        }}
                                      >
                                        Reportar
                                      </p>
                                      <S.Divider />
                                      <p
                                        onClick={() => {
                                          setOpenCancelModal(true);
                                          setChosenEntry(entry);
                                        }}
                                        style={{ color: "red"}}
                                      >
                                        Cancelar solicitação
                                      </p>
                                    </>
                                  )}
                                </S.OptionsGrid>
                              </S.OptionsContainer>
                            )}
                          </Grid>
                        </Grid>
                      ),
                    };
                  })
                }
              />
            </Grid>
          </S.TableGrid>
          {paginationHistorical?.length > 0 && (
            <S.PaginationGrid container justifyContent="center" sx={{ marginTop: "20px" }}>
              <Pagination
                count={paginationHistorical?.length}
                page={pageHistorical}
                siblingCount={1}
                boundaryCount={1}
                onChange={handleChangeHistorical}
              />
            </S.PaginationGrid>
          )}
        </Card>
      </Grid>
      <Modal
        size="md"
        open={openConfirmActualCashoutModal}
        onClose={() => setOpenConfirmActualCashoutModal(false)}
      >
        <S.ModalContainer container flexDirection="column" gap="20px">
          <Grid container gap="5px">
            <p className="modalTitle">Solicitar saque de</p>
            <p className="modalTitle bold">saldo atual</p>
          </Grid>
          <p className="cashoutValue">
            R${" "}
            {Number(
              ((chosenEntry?.value ?? 0) / 100).toFixed(2)
            ).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </p>
          <S.AlertGrid container gap="5px">
            <IoAlertCircleOutline size="24px" color="red" style={{ alignSelf: "center" }} />
            <p className="bold">Lembrete: </p>
            <p>Valor será creditado na conta em até 48h.</p>
          </S.AlertGrid>
          <Grid container justifyContent="space-between">
            <S.BorderedInputGrid>
              <S.Input
                name="description"
                id="description"
                placeholder="Insira o arquivo PDF"
                InputProps={{
                  readOnly: true,
                }}
                value={nfFile?.name ?? ""}
              />
              <ButtonCustom
                sx={{
                  width: "auto",
                  borderRadius: "0 5px 5px 0 !important",
                  fontSize: "18px",
                  fontWeight: 500,
                  height: "40px !important",
                  minWidth: "45px",
                  transform: "none !important",
                }}
                onClick={handleFileInputClick}
              >
                <IoCloudUploadOutline size="25px" />
              </ButtonCustom>
              <input
                type="file"
                accept=".pdf"
                onChange={handleFileChange}
                ref={hiddenFileInput}
                style={{ display: "none" }}
              />
            </S.BorderedInputGrid>
            <Grid container justifyContent="flex-end">
              <ButtonCustom
                label={
                  isWithdrawLoading ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <CircularProgress size={16} color="inherit" />
                      Solicitando...
                    </div>
                  ) : (
                    "Solicitar"
                  )
                }
                onClick={() => requestActualWithdraw()}
                disabled={isWithdrawLoading}
                sx={{
                  width: "150px",
                  fontSize: "18px",
                  fontWeight: 500,
                  height: "40px !important",
                }}
              />
            </Grid>
          </Grid>
        </S.ModalContainer>
      </Modal>
      <Modal
        size="md"
        open={openConfirmFutureCashoutModal}
        onClose={() => setOpenConfirmFutureCashoutModal(false)}
      >
        <S.ModalContainer container flexDirection="column" gap="20px">
          <Grid container gap="5px">
            <p className="modalTitle">Solicitar saque de</p>
            <p className="modalTitle bold">saldo futuro</p>
          </Grid>
          <Grid container flexDirection="column" alignContent="center">
            <p className="cashoutValue">
              R${" "}
              {Number(
                ((chosenEntry?.value ?? 0) / 100).toFixed(2)
              ).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
            <p className="discountWarning">
              Taxa de 5% (- R${" "}
              {Number(
                (((chosenEntry?.value ?? 0) * 0.05) / 100).toFixed(2)
              ).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              )
            </p>
          </Grid>
          <S.AlertGrid container gap="5px">
            <IoAlertCircleOutline size="24px" color="red" style={{ alignSelf: "center" }} />
            <p className="bold">Lembrete: </p>
            <p>Valor depende de aprovação e caso aprovado será abatido em 5%.</p>
          </S.AlertGrid>
          <Grid display="flex" justifyContent="flex-end">
            <ButtonCustom
              label="Solicitar"
              onClick={() => requestFutureWithdraw()}
              sx={{
                width: "150px",
                fontSize: "18px",
                fontWeight: 500,
                height: "40px !important",
              }}
            />
          </Grid>
        </S.ModalContainer>
      </Modal>
      <Modal
        open={openDetailsModal}
        onClose={() => {
          setOpenDetailsModal(false);
          setChosenEntry();
        }}
      >
        <S.DetailsMainGrid container flexDirection="column" gap="15px">
          <p className="titleDetails">Detalhes</p>
          <Grid container gap="20px">
            <Grid container justifyContent="space-between">
              <Grid container item flexDirection="column" xs={12} md={5.85} xl={5.85}>
                <p className="subtitleDetails">Nº do processo</p>
                <p className="valueDetails">{chosenEntry?.processNumber}</p>
              </Grid>
              <Grid container item flexDirection="column" xs={12} md={5.85} xl={5.85}>
                <p className="subtitleDetails">Status</p>
                <p className="valueDetails">{statusTranslation[chosenEntry?.status]}</p>
              </Grid>
            </Grid>
            <Grid container justifyContent="space-between">
              <Grid container item flexDirection="column" xs={12} md={5.85} xl={5.85}>
                <p className="subtitleDetails">Data da Solicitação</p>
                <p className="valueDetails">
                  {chosenEntry?.createdAt ? moment(chosenEntry?.createdAt).format("L") : ""}
                </p>
              </Grid>
              <Grid container item flexDirection="column" xs={12} md={5.85} xl={5.85}>
                <p className="subtitleDetails">Data da Resposta</p>
                <p className="valueDetails">
                  {chosenEntry?.resolvedAt ? moment(chosenEntry?.resolvedAt).format("L") : "-"}
                </p>
              </Grid>
            </Grid>
            <Grid container justifyContent="space-between">
              <Grid container item flexDirection="column" xs={12} md={5.85} xl={5.85}>
                <p className="subtitleDetails">Valor</p>
                <p className="valueDetails">
                  R${" "}
                  {Number((chosenEntry?.value / 100).toFixed(2)).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </Grid>
              <Grid container item flexDirection="column" xs={12} md={5.85} xl={5.85}>
                <p className="subtitleDetails">Tipo</p>
                <p className="valueDetails">
                  {chosenEntry?.type === "FUTURE_BALANCE" ? "Saldo Futuro" : "Saldo Atual"}
                </p>
              </Grid>
            </Grid>
            <Grid container justifyContent="space-between">
              <Grid container item flexDirection="column" xs={12} md={5.85} xl={5.85}>
                <p className="subtitleDetails">Projeto</p>
                <p className="valueDetails">
                  {chosenEntry?.balanceRelated?.[0]?.projectRelated.title ?? "-"}
                </p>
              </Grid>
              {(role !== "INFLUENCER") && (
                <Grid container item flexDirection="column" xs={12} md={5.85} xl={5.85}>
                  <p className="subtitleDetails">Empresa</p>
                  <p className="valueDetails">
                    {chosenEntry?.balanceRelated?.[0]?.leadRelated.businessName ?? "-"}
                  </p>
                </Grid>
              )}
            </Grid>
            <Grid container justifyContent="space-between">
              <Grid container item flexDirection="column" xs={12} xl={12}>
                <p className="subtitleDetails">Observações</p>
                <p className="valueDetails wrap">{chosenEntry?.miscInfo ?? "-"}</p>
              </Grid>
            </Grid>
            {chosenEntry?.invoiceCertificateURL && (
              <Grid container justifyContent="space-between">
                <a href={chosenEntry?.invoiceCertificateURL} target="_blank">
                  <ButtonCustom
                    label="Download NF"
                    sx={{
                      width: "150px",
                      height: "40px !important",
                      fontSize: "18px",
                      fontWeight: "500",
                    }}
                  />
                </a>
              </Grid>
            )}
          </Grid>
          <S.AlertGrid container gap="5px">
            <IoAlertCircleOutline color="red" style={{ alignSelf: "center" }} />
            <p className="subtitleDetails reminderDetails">Lembrete:</p>
            <p className="subtitleDetails">Valor será creditado na conta em até 48h.</p>
          </S.AlertGrid>
        </S.DetailsMainGrid>
      </Modal>
      <Modal size="md" open={openReportModal} onClose={() => setOpenReportModal(false)}>
        <S.ModalContainer container flexDirection="column" gap="20px">
          <Grid container gap="5px">
            <p className="modalTitle">Deseja</p>
            <p className="modalTitle bold">REPORTAR</p>
            <p className="modalTitle">este saque?</p>
          </Grid>
          <S.AlertGrid container gap="5px">
            <IoAlertCircleOutline size="24px" color="red" style={{ alignSelf: "center" }} />
            <p className="bold">Lembrete: </p>
            <p>O saque só pode ser reportado após 48h da solicitação.</p>
          </S.AlertGrid>
          <Grid container justifyContent="flex-end" gap="15px">
            <ButtonCustom
              label="Reportar"
              onClick={() => reportChosenWithdrawal()}
              sx={{
                width: "150px",
                fontSize: "18px",
                fontWeight: 500,
                height: "40px !important",
              }}
            />
          </Grid>
        </S.ModalContainer>
      </Modal>
      <Modal size="md" open={openCancelModal} onClose={() => setOpenCancelModal(false)}>
        <S.ModalContainer container flexDirection="column" gap="20px">
          <Grid container gap="5px">
            <p className="modalTitle">Deseja</p>
            <p className="modalTitle bold">CANCELAR</p>
            <p className="modalTitle">este saque?</p>
          </Grid>
          <S.AlertGrid container gap="5px">
            <IoAlertCircleOutline size="24px" color="red" style={{ alignSelf: "center" }} />
            <p className="bold">Lembrete: </p>
            <p>O saque só pode ser cancelado se estiver em processamento.</p>
          </S.AlertGrid>
          <Grid container justifyContent="flex-end" gap="15px">
            <ButtonCustom
              label="Cancelar"
              onClick={() => cancelChosenWithdrawal()}
              sx={{
                width: "150px",
                fontSize: "18px",
                fontWeight: 500,
                height: "40px !important",
              }}
            />
          </Grid>
        </S.ModalContainer>
      </Modal>
      <Modal
        size="md"
        open={openAttachNfModal}
        onClose={() => {
          setOpenAttachNfModal(false);
          setNfFile();
        }}
      >
        <S.ModalContainer container flexDirection="column" gap="20px">
          <Grid container gap="5px">
            <p className="modalTitle">Anexar nota fiscal</p>
          </Grid>
          <Grid container justifyContent="space-between">
            <S.BorderedInputGrid>
              <S.Input
                name="description"
                id="description"
                placeholder="Insira o arquivo PDF"
                InputProps={{
                  readOnly: true,
                }}
                value={nfFile?.name ?? ""}
              />
              <ButtonCustom
                sx={{
                  width: "auto",
                  borderRadius: "0 5px 5px 0 !important",
                  fontSize: "18px",
                  fontWeight: 500,
                  height: "40px !important",
                  minWidth: "45px",
                  transform: "none !important",
                }}
                onClick={handleFileInputClick}
              >
                <IoCloudUploadOutline size="25px" />
              </ButtonCustom>
              <input
                type="file"
                accept=".pdf"
                onChange={handleFileChange}
                ref={hiddenFileInput}
                style={{ display: "none" }}
              />
            </S.BorderedInputGrid>
            <Grid justifyContent="flex-end">
              <ButtonCustom
                label={
                  isWithdrawLoading ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <CircularProgress size={16} color="inherit" />
                      Anexando...
                    </div>
                  ) : (
                    "Salvar"
                  )
                }
                disabled={!nfFile || isWithdrawLoading}
                onClick={() => attachNfToWithdraw(chosenEntry?.id, setOpenAttachNfModal, "NF anexada com sucesso!")}
                sx={{
                  width: "150px",
                  fontSize: "18px",
                  fontWeight: 500,
                  height: "40px !important",
                }}
              />
            </Grid>
          </Grid>
        </S.ModalContainer>
      </Modal>
      <Modal open={openMaintenanceModal} onClose={() => setOpenMaintenanceModal(false)}>
        <MaintenanceModal />
      </Modal>
    </DashboardLayout>
  );
};

export default InfluencerCashout;